export function imgPreview(file: File): Promise<string | ArrayBuffer | null> {
    return new Promise((resolve) => {
        const fileReader = new FileReader();
        fileReader.onload = (): void => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
    });
}
